import React from 'react';
import { ProgressBar } from 'react-aria-components';

import { iconLoader } from '../../icons/glyphs/loader';
import { Icon } from '../../icons/icon';

/**
 * The loading indicator inside the combobox field: Tractie's loader glyph,
 * announced as an indeterminate progress bar named "Loading".
 *
 * @param props.className - The spinner class from the presentation's CSS
 *   module, so every presentation styles it from the module it imports.
 */
export function ComboboxSpinner(props: {
  className: string | undefined;
}): React.ReactElement {
  return (
    <ProgressBar
      isIndeterminate
      aria-label="Loading"
      className={props.className}
    >
      <Icon glyph={iconLoader} size="xs" />
    </ProgressBar>
  );
}
